var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDlocal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 443.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #1043fa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.2,340.88V6.39c0-3.52-2.87-6.39-6.39-6.39h-70.82c-3.52,0-6.39,2.87-6.39,6.39v152.99C103.29,109.84,0,179.03,0,292.45c0,80.63,45.92,152.92,133.14,151.13,37.61-.65,70.43-19.75,86.53-55.54v7.76c1.73,48.04,49.08,50.58,89.86,42.3,3-.62,5.08-3.29,5.05-6.36l-.49-42.73c-.03-3.39-2.77-6.13-6.16-6.29-19.98-.98-20.76-16.2-20.76-41.88M205.95,303.83c0,35.26-23.27,65.61-59.71,65.61-44.78,0-63.29-35.72-63.29-77.02,0-70.82,60.95-96.31,119.61-64.53,2.09,1.11,3.36,3.36,3.36,5.7v70.2l.03.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 416.92,
    y: 227.2,
    width: 83.08,
    height: 83.08,
    rx: 5.28,
    ry: 5.28
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlocal);
export default __webpack_public_path__ + "static/media/dlocal.86292448857b727bce00471e9b8b0696.svg";
export { ForwardRef as ReactComponent };